<template>
  <div class="card">
    <header class="card-header">
      <p class="card-header-title">Parts</p>
    </header>
    <div class="card-content">
      <NoDataMessage v-if="!cardData" />
      <div v-else class="columns is-multiline">
        <div v-for="part in cardData" :key="part.d11_part" class="column is-6">
          <div class="media">
           <!--  <div class="media-left">
              <figure class="image is-64x64">
                <img :src="part.d11_icon" alt="display icon" />
              </figure>
            </div> -->
            <div class="media-content">
              <DataItem :label="part.d11_part" :data="part.d11_part">{{part.d11_value}}</DataItem>
            </div>
            <!-- <div class="media-right">
              <figure class="image is-32x32">
                <img src="@/assets/parts/value-icon.png" alt="high value" />
              </figure>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NoDataMessage from "@/components/NoDataMessage.vue";
import DataItem from "@/components/DataItem.vue";

export default {
  components: { NoDataMessage, DataItem },
  name: "CardParts",
  props: { cardData: Array },
};
</script>
